import { sift } from "radash";
import type { RouteObject } from "react-router";
import authRoutes from "@/features/auth/routes";
import dashboard1Routes from "@/features/dashboard-1/routes";
import dashboard2Routes from "@/features/dashboard-2/routes";
import Root from "../shared/views/root";
import Error from "../shared/views/error";
import directInvestments from "@/features/direct-investments/routes";
import internationalFinancial from "@/features/international-financial/routes";
import strategicProjects from "@/features/strategic-projects/routes";
import tableRoutes from "@/features/table/routes";
import projectTableRoutes from "@/features/project-table/routes";
import directProjectsRoutes from "@/features/direct-projects/routes";
import internationalProjectsRoutes from "@/features/international-projects/routes";

export const routes: RouteObject[] = [
  {
    id: "root",
    path: "/",
    element: <Root />,
    loader: async () => null,
    errorElement: <Error />,
    children: sift(
      [
        dashboard1Routes,
        dashboard2Routes,
        directInvestments,
        internationalFinancial,
        strategicProjects,
        tableRoutes,
        projectTableRoutes,
        directProjectsRoutes,
        internationalProjectsRoutes,
      ].flat(),
    ),
  },
  authRoutes,
];
